
export const DUPLICATION_ERROR_CODE = 'newbelarus.authorization'
